export const Bio = {
  name: "Moksh Shah",
  roles: [
    "Android Developer",
    "Flutter Developer",
    "Game Developer",
    // "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/shahmoksh22",
  resume:
    "/SHAH MOKSH.pdf",
  linkedin: "https://www.linkedin.com/in/shah-moksh-018970219/",
  twitter: "https://x.com/shahmoksh22",
  insta: "https://www.instagram.com/shahmoksh22/",
  facebook: "https://www.facebook.com/shahmoksh22/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "Flutter",
        image: "/flutter.webp",
      },
      {
        name: "Dart",
        image:
          "/dart.png",
      },
      {
        name: "HTML",
        image: "/html.png",
      },
      {
        name: "CSS",
        image:
          "/css.png",
      },
      {
        name: "JavaScript",
        image:
          "/js.png",
      },
      {
        name: "Bootstrap",
        image:
          "/bootstrap.png",
      },
      {
        name: "Material UI",
        image:
          "/materialui.png",
      }
    ],
  },
  {
    title: "Backend",
    skills: [

      {
        name: "Python",
        image:
          "/python.svg",
      },
      {
        name: "MySQL",
        image:
          "/mysql.svg",
      },
      {
        name: "Firebase",
        image: "/firebase.svg",
      },
      {
        name: "C++",
        image:
          "/c++.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "/java.svg",
      },
      {
        name: "Kotlin",
        image:
          "/Kotlin.svg",
      },
      {
        name: "XML",
        image:
          "/xml.svg",
      },
      {
        name: "Android Studio",
        image:
          "/androidstudio.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "/git.png",
      },
      {
        name: "GitHub",
        image:
          "/GitHub.svg",
      },
      {
        name: "Netlify",
        image:
          "/netlify.png",
      },
      {
        name: "VS Code",
        image:
          "/vscode.png",
      },
      {
        name: "Figma",
        image:
          "/Figma.svg",
      },
      {
        name: "Xcode",
        image:
          "/Xcode.png",
      },
      {
        name: "Cocos2d-X",
        image:
          "/Cocos2d-X.svg",
      },
      {
        name: "PhotoShop",
        image:
          "/Photoshop.svg",
      },
      {
        name: "ChatGpt",
        image:
          "/ChatGPT.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C510BAQHREV60Xwu4sQ/company-logo_200_200/company-logo_200_200/0/1630633117662/gameadzone_logo?e=2147483647&v=beta&t=K_pZUFCxE0DUvvlEmnXg_lZ8dLWAZJqw3fHJl5y1lOc",
    role: "Android Developer",
    company: "GameAdZone Pvt. Ltd.",
    date: "Oct 2023 - Currently",
    desc: "Working on Adding New Features in Game.",
    skills: [
      "Android Studio",
      "Java",
      "Kotlin",
      "Firebase",
      "Xml",
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  }
];

export const education = [
  {
    id: 0,
    img: "data:image/jpeg;base64,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",
    school: "Swarrnim Startup and Innovations University - Gandhinagarr",
    date: "July 2023 - Currently",
    grade: "SGP : 9.00",
    desc: "I am currently pursuing a Bachelor's degree in Information and Technology at Swarrnim Startup and Innovations University - Gandhinagar. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Information & Technology - BSC-IT",
  },
  {
    id: 1,
    img: "https://sbvsurat.com/wp-content/uploads/2024/05/SBV-logo.svg",
    school: "Sanskar Bharti Vidyalaya, Surat",
    date: "Apr 2021 - March 2023",
    grade: "49.69%",
    desc: "I completed my class 12 high school education at Sanskar Bharti Vidyalaya, Surat, where I studied Science.",
    degree: "GSEB HSC Science",
  },
  {
    id: 2,
    img: "https://sbvsurat.com/wp-content/uploads/2024/05/SBV-logo.svg",
    school: "Sanskar Bharti Vidyalaya, Surat",
    date: "Apr 2017 - Apr 2021",
    grade: "63%",
    desc: "I completed my class 10 education at Sanskar Bharti Vidyalaya, Surat.",
    degree: "GSEB SSC",
  },
];

export const projects = [
  {
    id: 1,
    title: "Cooking Zone - Restaurant Game",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Join a amazing food cooking game!",
    image:
      "https://lh3.googleusercontent.com/kbc7D8WcXr3IzPW40xU2u3u2E93UZUWT1q9NvZLpRgD0HhXP4ExatuuShzaTCljYfdQ",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.cookingzone.restaurent.game",
  },
  {
    id: 1,
    title: "Indian Wedding: DressUp Makeup",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Wedding stylist dress up makeover and Plan fashion doll makeup games for girls",
    image:
      "https://lh3.googleusercontent.com/YhZt28ndVNQgPgO2_TCEc6qcHxYtuv4GJEPn-YkhroYmZ8jHxc_nixabUpaRxelElg",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
  },
  {
    id: 1,
    title: "Unicorn newborn babysitter",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Play with colorfull unicorn newborn and learn babysitting with fun.",
    image:
      "https://lh3.googleusercontent.com/PxcA5D4Gb6gpOL8-KmAkdCplMyTeOIFZHNsrNZjGgCQV6YQClfG7xO9IfddpbtoVs30",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.gameiavo.momunicorn.pragnant.care.games",
  },
  {
    id: 1,
    title: "Newborn Baby Shower Party Game",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Its time for newborn caring guide and throw amazing baby shower party.",
    image:
      "https://lh3.googleusercontent.com/Lk0zsyvwZ0UwPCr1xRFzIwV8qcZDlKZjqy_Tujw_YhRJy4hqjwlouMPny7_r2ew2zIc",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.pigamesstudio.momspregnantcare",
  },
  {
    id: 1,
    title: "Mermaid Babyshower Party",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Join the mermaid on a magical ocean adventure full of fun and surprises",
    image:
      "https://lh3.googleusercontent.com/wp6miNPZc7I7AE0x3IZ3-L7RNlJ59mA9TmrLMut-7LLExgYKsU0wrb3WDWk12SWF6Aw",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob",
      "RevenueCat",
      "Purchase",
      "Billing"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.pigamesstudio.newbornmermaid",
  },
  {
    id: 1,
    title: "Cute Girl Daycare & Dress up",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Does your Little one loves Educational , Daycare activities & interactive games?",
    image:
      "https://lh3.googleusercontent.com/AOl3YsPWOUn0rxwK1GPKyd1HoOO0OWFdQcTwIKPsHaLrUhxQqYktnOZ3Ar3s4prJWA",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.blackatomgames.cutegirldaycaredressup",
  },
  {
    id: 1,
    title: "Crazy Dino Care Dress Up",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Fun dinosaur care game with interactive activities and dress up",
    image:
      "https://lh3.googleusercontent.com/fhlyzpLvyKFdA7Jl9kNoU0PICSyriS7HOAr73mFpcCiBgnE1VzFuWmyvJ6dfCrtwhA",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.blackatomgames.crazydinocaregame",
  },
  {
    id: 1,
    title: "Pet animal care game",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Cute pet animal pig is waiting for your gentle daycare help.",
    image:
      "https://lh3.googleusercontent.com/3wWQ_56OoiRRH43bCsOKTiHqJxSYC3-QncLwXimLHKba9SQZ2bHbh-7WoqKP-ifRSA",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.babypiggames.babypigdaycare",
  },
  {
    id: 1,
    title: "Puppy Newborn BabyShower",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Puppy newborn BabyShower is caring game. Puppy pet daycare.",
    image:
      "https://lh3.googleusercontent.com/iFGP6P2BF0gzVLjuMuHBM5ePlq58-dyIgRekK-hfGqBK6EXV2vpYQwz_OKgQP_lMH5g",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.iapgames.puppynewbornbaby",
  },
  {
    id: 1,
    title: "Princess BabyShower Party",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Its time for newborn babyshower party caring activity and celebrate",
    image:
      "/princessbabyshowergame.png",
    tags: [
      "Game",
      "Cpp",
      "Java",
      "Firebase",
      "Admob"
    ],
    category: "game",
    // github: "https://play.google.com/store/apps/details?id=com.gameiavo.wedding.makeup.fashion.stylist",
    webapp: "https://play.google.com/store/apps/details?id=com.sniffygames.princessbabyshowerparty",
  },
  // {
  //   id: 9,
  //   title: "Neminath Traders Website",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "It is a Company Website to show all the products to consumer and it also helps to users to get direction, directly calling to office for any inquiry or to get support.",
  //   image:
  //     "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj-YvYzK0X5eCt0xZls099IFjURDqdqZk9u9y2qDs-EWkonIMKzmnI_NviIe1XYAP8rtL57XF68BxDn0C2lT0IVGTvSt6b05dFmDdrngxERDu82DmsaMalOMsYZKslznVPhRvfqx7zqFFn5qE-UD1tgh-qUnNBQO73HNKv6oJJ8EAbJCIjaMMiOmRjjANue/s2856/Screenshot%202024-10-01%20at%2012.32.27%E2%80%AFAM.png",
  //   tags: [
  //     "HTML",
  //     "CSS",
  //     "Javascript",
  //     "Tailwind Css",
  //   ],
  //   // category: "web app",
  //   github: "https://lh6.googleusercontent.com/Bu-pRqU_tWZV7O3rJ5nV1P6NjqFnnAs8kVLC5VGz_Kf7ws0nDUXoGTc7pP87tyUCfu8VyXi0YviIm7CxAISDr2lJSwWwXQxxz98qxVfMcKTJfLPqbcfhn-QEeOowjrlwX1LYDFJN",
  //   webapp: "https://neminathtraders.great-site.net/",
  // },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
